import axios from 'axios';

const portalBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL
  || `${window.location.protocol}//${window.location.host}`;

const isLocalDevelopment = ['localhost', '127.0.0.1'].includes(window.location.hostname);

const backendEntryUrl = process.env.REACT_APP_FEES_API_BASE_URL
  || (isLocalDevelopment
    ? '/backend/public/index.php'
    : `${portalBaseUrl.replace(/\/$/, '')}/backend/public/index.php`);

const feesClient = axios.create({
  baseURL: backendEntryUrl,
  headers: { 'Content-Type': 'application/json' },
});

const request = async (config) => {
  const response = await feesClient({
    ...config,
    url: '',
    params: {
      ...(config.params || {}),
      route: `/api/fees${config.url}`,
    },
  });
  return response.data;
};

export const ListServices = async () => request({
  method: 'get',
  url: '/services',
});

export const AddServices = async (name, description, unitlabel, metered) => request({
  method: 'post',
  url: '/services',
  data: {
    name,
    description,
    unit_label: unitlabel,
    metered: metered === '1' || metered === true,
  },
});

export const UpdateServices = async (id, name, description, unitlabel, metered) => request({
  method: 'put',
  url: `/services/${id}`,
  data: {
    name,
    description,
    unit_label: unitlabel,
    metered: metered === '1' || metered === true,
  },
});

export const DeleteServices = async (id) => request({
  method: 'delete',
  url: `/services/${id}`,
});

export const ListServicePrices = async (serviceId = '') => request({
  method: 'get',
  url: '/service-prices',
  params: serviceId ? { service_id: serviceId } : undefined,
});

export const AddServicePrices = async (
  location,
  serviceid,
  pricetype,
  currency,
  unitprice,
  effectivefrom,
  effectiveto
) => request({
  method: 'post',
  url: '/service-prices',
  data: {
    service_id: serviceid,
    price_type: pricetype,
    currency,
    unit_price: unitprice,
    effective_from: effectivefrom || null,
    effective_to: effectiveto || null,
  },
});

export const UpdateServicePrices = async (
  location,
  priceid,
  serviceid,
  pricetype,
  currency,
  unitprice,
  effectivefrom,
  effectiveto
) => request({
  method: 'put',
  url: `/service-prices/${priceid}`,
  data: {
    service_id: serviceid,
    price_type: pricetype,
    currency,
    unit_price: unitprice,
    effective_from: effectivefrom || null,
    effective_to: effectiveto || null,
  },
});

export const DeleteServicePrices = async (location, priceid) => request({
  method: 'delete',
  url: `/service-prices/${priceid}`,
});

export const ListPackages = async () => request({
  method: 'get',
  url: '/packages',
});

export const AddPackage = async (name, description, serviceIds) => request({
  method: 'post',
  url: '/packages',
  data: {
    name,
    description,
    includes_all_services: false,
    service_ids: serviceIds,
  },
});

export const UpdatePackage = async (id, name, description, serviceIds) => request({
  method: 'put',
  url: `/packages/${id}`,
  data: {
    name,
    description,
    includes_all_services: false,
    service_ids: serviceIds,
  },
});

export const UpdatePackageServices = async (id, serviceIds) => request({
  method: 'put',
  url: `/packages/${id}/services`,
  data: {
    service_ids: serviceIds,
  },
});

export const DeletePackage = async (id) => request({
  method: 'delete',
  url: `/packages/${id}`,
});

export const ListPlans = async (packageId = '') => request({
  method: 'get',
  url: '/plans',
  params: packageId ? { package_id: packageId } : undefined,
});

export const AddPlan = async (plan) => request({
  method: 'post',
  url: '/plans',
  data: plan,
});

export const UpdatePlan = async (id, plan) => request({
  method: 'put',
  url: `/plans/${id}`,
  data: plan,
});

export const DeletePlan = async (id) => request({
  method: 'delete',
  url: `/plans/${id}`,
});
